import React from "react";
import "./index.scss";
import userCases from "../PageStaticConf/UserCases";
import banner2 from "../assets/home-page/banner2.png"
import OSS_URL from "../constants/ossUrl";

class UserCase extends React.Component {

    

    render() {
        return <div className="user-case">
            <div className="user-case-header">
                <img src={banner2} />
                <div className="user-case-title">
                    <h2>用户案例</h2>
                    <p>慧脑云将始终与脑疾病方面的临床医生以及脑科学领域的科研工作者并肩前行，走在临床与科研的最前沿。</p>
                </div>
                <div className="user-case-intruduce">
                    <h3>丰富的医院与高校服务经验</h3>
                    <p>慧脑云产品覆盖超过30家全国顶级临床机构与科研院所，全方位保障了医院与高校的临床与科研需求。</p>
                    <p>作为项目参与单位，慧脑云深度参与了多项脑科学与脑医学国家重大专项，专注于脑科学与脑医学产品的快速落地。</p>
                </div>
            </div>
            <div className="content-header">
                <div className="case-Chinese">合作案例</div>
                <div className="case-English">
                    <p>&nbsp;</p>
                    <p>CASES</p>
                </div>
            </div>
            <div className="case-show">
                {
                    userCases.map((item, index) => {
                        return <div className="case-item">
                        <div style={{display: "flex"}}>
                            <div className="item-content">
                                <div className="item-container">
                                    <img src={item.caseLogo} className="case-logo" />
                                    <div className="case-text">
                                        <div className="case-title">{item.title}</div>
                                        {
                                            item.desc.map((el, i) => {
                                                return <div className="case-desc" style={{ marginBottom: i == item.desc.length - 1 ? "0" : ".3333rem" }}>{el}</div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <img src={item.caseImg} className="case-img" />
                        </div>
                        {
                            index == userCases.length - 1
                                ?
                            null
                                :
                            <div className="border-line">
                                <div className="left-line"></div>
                            </div>
                        }
                    </div>
                    })
                }
            </div>
        </div>
    }
}

export default UserCase;